// media query golbal values

export const FIRST_MEDIA_QUERY = '(min-width:1025px)';
export const SECOND_MEDIA_QUERY = '(min-width:768px)';
